import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Course-owned shareable resources (Phase v3).
 * Wraps `CourseResourceController` endpoints. Authorization is enforced
 * server-side via `SecurityService.canViewEndeavor` (read paths) and
 * `SecurityService.canAdministerEndeavor` (write paths).
 */
export const CourseResourceApi = {
  /**
   * @param {number|string} endeavorId
   * @param {{kind?: 'quiz'|'flashcard_deck'|'audio'}} [opts]
   */
  list: async (endeavorId, { kind } = {}) => {
    const qs = kind ? `?kind=${encodeURIComponent(kind)}` : '';
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/resources${qs}`, { method: 'GET' });
  },

  get: async (endeavorId, resourceId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/resources/${resourceId}`, { method: 'GET' }),

  /**
   * Create a course-owned resource. `body` shape:
   *   { kind, title, description?, sourceDocumentId?, payloadRef?, payloadJson?, visibility? }
   */
  create: async (endeavorId, body) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/resources`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),

  update: async (endeavorId, resourceId, body) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/resources/${resourceId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),

  remove: async (endeavorId, resourceId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/resources/${resourceId}`, { method: 'DELETE' }),

  /** Submit an attempt at a resource (always recorded for the calling user). */
  submitAttempt: async (endeavorId, resourceId, body = {}) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/resources/${resourceId}/attempts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),

  /**
   * List attempts for a resource. Server returns only the caller's own
   * attempts unless they can administer the course (and even then,
   * student_shared courses still hide peer attempts).
   */
  listAttempts: async (endeavorId, resourceId) =>
    fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/courses/${endeavorId}/resources/${resourceId}/attempts`, { method: 'GET' }),
};
